import { useMemo } from 'react'
import { GridOptions } from 'ag-grid-community'
import { UserApiTokenRow } from '../UserApiTokenRow'
import { useColumnDefs } from './useColumnDefs'
import { DefaultCellRenderer } from '../../../containers/BulkSheetView/components/cellRenderer'
import { columnTypes } from '../../../containers/commons/AgGrid'

export const useGridOptions = (): GridOptions<UserApiTokenRow> => {
  const columnDefs = useColumnDefs()

  return useMemo(
    () => ({
      columnDefs,
      context: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        cellRenderer: DefaultCellRenderer,
      },
      rowHeight: 38,
      headerHeight: 38,
      enableRangeSelection: true,
      rowSelection: 'single',
      suppressRowClickSelection: true,
      getRowId: params => params.data.uuid,
      allowContextMenuWithControlKey: true,
      preventDefaultOnContextMenu: true,
      columnTypes: columnTypes(),
    }),
    [columnDefs]
  )
}
